<template>
  <Layout>
    <PageHeader :title="title" :items="braedcrumb" />
    <div>
      <b-row>
        <b-col>
          <b-card>
            <b-row>
              <b-col sm="12" md="4">
                <div>
                  <label>{{ $t("code") }}</label>
                  <b-form-input
                    :placeholder="$t('code')"
                    v-model="OrganizationAccount.code"
                    type="text"
                  ></b-form-input>
                </div>
              </b-col>
              <b-col sm="12" md="4">
                <div>
                  <label>{{ $t("accountname") }}</label>
                  <b-form-input
                    v-model="OrganizationAccount.accountname"
                    :placeholder="$t('accountname')"
                    type="number"
                  ></b-form-input>
                </div>
              </b-col>
              <b-col sm="12" md="4">
                <div>
                  <label>{{ $t("organization") }}</label>
                  <v-select
                    :options="OrganizationList"
                    :reduce="(item) => item.id"
                    :placeholder="$t('ChooseBelow')"
                    label="name"
                    v-model="OrganizationAccount.organizationid"
                    @input="ChangeOrganization"
                  ></v-select>
                </div>
              </b-col>
              <b-col sm="12" md="4">
                <div class="mt-2">
                  <label>{{ $t("purchasebase") }}</label>
                  <v-select
                    :options="PurchaseBaseList"
                    :reduce="(item) => item.id"
                    :placeholder="$t('ChooseBelow')"
                    label="name"
                    v-model="OrganizationAccount.purchasebaseid"
                    @input="ChangePurchasebase"
                  ></v-select>
                </div>
              </b-col>
              <b-col sm="12" md="4">
                <div class="mt-2">
                  <label>{{ $t("bank") }}</label>
                  <v-select
                    :options="BankList"
                    :reduce="(item) => item.id"
                    :placeholder="$t('ChooseBelow')"
                    label="name"
                    v-model="OrganizationAccount.bankid"
                    @input="ChangeBank"
                  ></v-select>
                </div>
              </b-col>
              <b-col sm="12" md="4">
                <div class="mt-2">
                  <label for>{{ $t("state") }}</label>
                  <div>
                    <v-select
                      :options="StateList"
                      :reduce="(item) => item.id"
                      :placeholder="$t('ChooseBelow')"
                      label="name"
                      v-model="OrganizationAccount.stateid"
                    ></v-select>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <b-row>
              <b-col class="text-left">
                <b-button
                  @click="$router.push('/managment/organizationaccount')"
                  class="d-inline-block "
                  variant="danger"
                  ><i class="dripicons-arrow-thin-left"></i>
                  {{ $t("back") }}</b-button
                >
              </b-col>
              <b-col style="text-align: right !important; " class="text-right">
                <b-button
                  @click="SaveData"
                  class="d-inline-block "
                  variant="success"
                  ><i class="dripicons-checkmark"></i>
                  {{ $t("save") }}</b-button
                >
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </Layout>
</template>
<script>
import vSelect from "vue-select";
import Layout from "../../../router/layouts/main.vue";
import PageHeader from "@/components/page-header";
import OrganizationAccountService from "@/services/others/organizationaccount.service";
import OrganizationService from "@/services/others/organization.service";
import BankService from "@/services/info/bank.service";
import HelperService from "@/services/others/helper.service";
import Multiselect from "vue-multiselect";
export default {
  components: { Multiselect, Layout, PageHeader, vSelect },
  data() {
    return {
      title: this.$t("OrganizationAccount"),
      braedcrumb: [
        {
          text: this.$t("Management"),
        },
        {
          text: this.$t("OrganizationAccount"),
          active: true,
        },
      ],
      items: [],
      // //  show: false,
      OrganizationAccount: {},
      filter: {
        oblastid: 0,
        regionid: 0,
        isfarmfy: false,
      },
      StateList: [],
      BankList: [],
      OrganizationList: [],
      PurchaseBaseList: [],
      lang: "ru",
    };
  },
  created() {
    this.lang = localStorage.getItem("locale") || "ru";
    this.show = true;
    HelperService.GetStateList().then((res) => {
      this.StateList = res.data;
    });
    HelperService.GetAllPurchaseBase().then((res) => {
      this.PurchaseBaseList = res.data;
    });

    BankService.GetAll().then((res) => {
      this.BankList = res.data;
    });
    OrganizationService.GetAll(
      this.filter.oblastid,
      this.filter.regionid,
      this.filter.isfarmfy
    ).then((res) => {
      this.OrganizationList = res.data;
    });
    OrganizationAccountService.Get(this.$route.params.id)
      .then((res) => {
        this.show = false;
        this.OrganizationAccount = res.data;
      })
      .catch((error) => {
        this.$notification(error.response.data.error, "danger");
      });
  },
  directives: {},
  methods: {
    check() {
      if (
        this.OrganizationAccount.code === 0 ||
        this.OrganizationAccount.code === null ||
        this.OrganizationAccount.code === undefined ||
        this.OrganizationAccount.code === ""
      ) {
        this.$notification(this.$t("codeNotSelected"), "danger");
        return false;
      }
      if (
        this.OrganizationAccount.accountname === 0 ||
        this.OrganizationAccount.accountname === null ||
        this.OrganizationAccount.accountname === undefined ||
        this.OrganizationAccount.accountname === ""
      ) {
        this.$notification(this.$t("accountnameNotSelected"), "danger");
        return false;
      }
      if (
        this.OrganizationAccount.organizationid === 0 ||
        this.OrganizationAccount.organizationid === null ||
        this.OrganizationAccount.organizationid === undefined ||
        this.OrganizationAccount.organizationid === ""
      ) {
        this.$notification(this.$t("organizationNotSelected"), "danger");
        return false;
      }
      if (
        this.OrganizationAccount.purchasebaseid === 0 ||
        this.OrganizationAccount.purchasebaseid === null ||
        this.OrganizationAccount.purchasebaseid === undefined ||
        this.OrganizationAccount.purchasebaseid === ""
      ) {
        this.$notification(this.$t("purchasebaseNotSelected"), "danger");
        return false;
      }
      if (
        this.OrganizationAccount.bankid === 0 ||
        this.OrganizationAccount.bankid === null ||
        this.OrganizationAccount.bankid === undefined ||
        this.OrganizationAccount.bankid === ""
      ) {
        this.$notification(this.$t("bankNotSelected"), "danger");
        return false;
      }
      if (
        this.OrganizationAccount.stateid === 0 ||
        this.OrganizationAccount.stateid === null ||
        this.OrganizationAccount.stateid === undefined ||
        this.OrganizationAccount.stateid === ""
      ) {
        this.$notification(this.$t("stateNotSelected"), "danger");
        return false;
      }

      return true;
    },
    ChangeOrganization() {
      if (!!this.OrganizationAccount.organizationid) {
        this.OrganizationAccount.organizationname = this.OrganizationList.filter(
          (item) => this.OrganizationAccount.organizationid === item.id
        )[0].name;
      }
    },
    ChangePurchasebase() {
      if (!!this.OrganizationAccount.purchasebaseid) {
        this.OrganizationAccount.purchasebasename = this.PurchaseBaseList.filter(
          (item) => this.OrganizationAccount.purchasebaseid === item.id
        )[0].name;
      }
    },
    ChangeBank() {
      if (!!this.OrganizationAccount.bankid) {
        this.OrganizationAccount.bankname = this.BankList.filter(
          (item) => this.OrganizationAccount.bankid === item.id
        )[0].name;
      }
    },
    SaveData() {
      if (!this.check()) {
        return false;
      }
      OrganizationAccountService.Update(this.OrganizationAccount)
        .then((res) => {
          this.$notification(this.$t("SaveSuccess"), "success");
          this.$router.push({ name: `organizationaccount` });
        })
        .catch((err) => {
          this.$notification(this.$t(err.response.data.error), "danger");
        });
    },
  },
};
</script>

<style></style>
